import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@dnb/eufemia'
import PropTypes from 'prop-types';
import { Grid } from '@dnb/eufemia'
import StatusMessage from '../statusMessage/StatusMessage';
import DnbStatusLink from '../dnb-status-link/DnbStatusLink';
import format from 'date-fns/format';
import { chevron_right as ChevronRight } from '@dnb/eufemia/icons';
import { home as home } from '@dnb/eufemia/icons';
import { Button } from '@dnb/eufemia';
import './status-messages-wrapper.css';
import Card from '@dnb/eufemia/components/card/Card';

const StatusMessageWrapper = ({ incidents, updateTimestamp, includedComponents }) => {
  const { t, i18n } = useTranslation();
  const incidentsList = incidents
    .filter((e) => e.status !== 'resolved')
    .filter((e) => {
      if (e.components.length > 0) {
        if (e.components[0].id in includedComponents) {
          return e;
        }
      } else {
        return e;
      }
    })                  // If we want to filter out only the components that are affected

    .map((incident) => {
      return <StatusMessage key={incident.id} incident={incident} />;
    });


  const lastUpdated = updateTimestamp !== null ? format(updateTimestamp, 'dd.MM.yyyy, HH:mm') : '';

  // Dirty hack to get relative path on incidents link
  var incidents_location = '';
  if (location.pathname === "/") {
    incidents_location = '/incidents';
  }
  else {
    incidents_location = location.pathname + '/incidents';
  }
  if (incidentsList.length > 0) {
    //return <ul className='dnb-status-messages-wrapper'>{incidentsList}</ul>;
    //return <Flex.Container className='dnb-status-messages-wrapper' direction='vertical' gap='small'>{incidentsList}</Flex.Container>;
    return incidentsList;
  } else {
    // Should use card here, to get the same style as the status messages
    return (
      <Card className='dnb-no-statuses' outline='none' backgroundColor="pistachio">
        <Grid.Container columnGap='medium'>
          <Grid.Item span={{
                   small: 'full',
                   medium: [1, 10],
                   large: [1, 10]
           }}>  
          <h1 className="dnb-heading-large">
            {t('All our systems and services are working as normal')}
          </h1>
           <span className='dnb-no-statuses__last-updated'>
              {t('Last updated')}: <time dateTime={lastUpdated}>{lastUpdated}</time>
           </span>
          </Grid.Item>
          <Grid.Item span={{
                   small: 'full',
                   medium: [11, 'end'],
                   large: [11, 'end']
           }}>
            <Button className='dnb-button-custom' text={t('See incidents')} variant="tertiary" href={incidents_location} target="_self" title={t('Go to the incident overview')} icon={ChevronRight} />
          </Grid.Item>
        </Grid.Container>
      </Card>
    );
  }
};

export default StatusMessageWrapper;

StatusMessageWrapper.propTypes = {
  incidents: PropTypes.array,
  updateTimestamp: PropTypes.instanceOf(Date),
  includedComponents: PropTypes.object,
};
